var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6968 12.6005C11.4126 12.8847 10.9535 12.8847 10.6693 12.6005L9.12426 11.0555C8.84003 10.7713 8.84003 10.3122 9.12426 10.0279C9.40848 9.74371 9.86761 9.74371 10.1518 10.0279L11.1794 11.0555L13.7593 8.47565C14.0435 8.19143 14.5026 8.19143 14.7868 8.47565C15.0711 8.75987 15.0711 9.219 14.7868 9.50322L11.6968 12.6005ZM7.28774 10.9316C7.28774 8.11126 9.56881 5.8302 12.3892 5.8302C13.1762 5.8302 13.9123 6.01239 14.5755 6.32576V1.45755C14.5755 0.655897 13.9196 0 13.1179 0H1.45755C0.655897 0 0 0.655897 0 1.45755V14.5755L2.9151 11.6604H7.28774C7.28774 11.5365 7.29503 11.4199 7.30961 11.296C7.29503 11.1721 7.28774 11.0555 7.28774 10.9316Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1cc93040be63e5bb5989763cc1fae3d6.svg";
export { ForwardRef as ReactComponent };